import { Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { DATA_LIMIT } from '../../data/constants';
import { formatDate, getParameters } from '../../lib/helper';
import ConfirmationModal from '../Modals/ConfirmationModal';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import MatTable from '../Tables/MatTable';
import Loader from '../CommonComp/CustomLoading/Loader';
import {
  deletePartyDetail,
  getAllBillerPartyListing,
} from '../../Services/partyApis';
import { partyItemsSelector } from '../../redux/party';

const limit = DATA_LIMIT;

const column = [
  {
    label: 'Biller Name',
    id: 'name',
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <Link
        className="textDecoration-none link-text"
        to={`billerDetail/${row?._id}`}
      >
        <Typography
          variant="span"
          style={{ whiteSpace: 'nowrap', padding: '1rem' }}
          // className={'link-text'}
          // onClick={() => {
          //   customHistory.push(`order/orderDetails/${columnData}`);
          // }}
        >
          {columnData}
        </Typography>
      </Link>
    ),
  },
  {
    label: 'Party Name',
    id: 'name',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || '-'}
      </span>
    ),
  },
  {
    label: 'Organization Name',
    id: 'organizationName',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || '-'}
      </span>
    ),
  },
  {
    label: 'Is Active',
    id: 'isActive',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData ? (
          <span
            style={{
              display: 'inline-block',
              whiteSpace: 'nowrap',
              padding: '0.2rem 0.5rem',
              backgroundColor: '#272727',
              color: 'white',
              borderRadius: '1rem',
            }}
          >
            <h5>True</h5>
          </span>
        ) : (
          '-' || '-'
        )}
      </span>
    ),
  },
  {
    label: 'Created At',
    id: 'createdAt',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {formatDate(columnData, 'dd-mm-yyyy') || '-'}
      </span>
    ),
  },
];

function AllBillerParty() {
  const [tableListing, setTableListing] = useState([]);
  const [isLoadingState, setIsLoadingState] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [page, setPage] = useState(1);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [allParams, setAllParams] = useState(getParameters());
  const { billerPartyList } = useSelector(partyItemsSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      partyType: 'Biller',
      ...allParams,
      ...params,
    };
    dispatch(getAllBillerPartyListing(payload));
    setPage(Number(payload.page));
  };
  useEffect(() => {
    getListing();
  }, []);
  useEffect(() => {
    if (billerPartyList?.items?.results?.length >= 0) {
      setTableListing(billerPartyList?.items?.results);
    }
  }, [billerPartyList.items]);

  const actionBody = (data) => {
    return (
      <>
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={async () => {
              handleCofirmModalOpen(true);
              setDeleteData(data?._id);
            }}
            sx={{
              padding: '5px 10px',
              marginRight: 1,
              fontSize: '12px',
              bgcolor: 'buttonDanger.main',
              color: 'buttonSecondary.contrastText',
            }}
          >
            Delete
          </CustomButton>
        </div>
      </>
    );
  };
  const handleDelete = async (value) => {
    setIsLoadingState(true);
    try {
      if (value && deleteData) {
        const resp = await deletePartyDetail(deleteData);
        if (resp) {
          getListing();
        }
        setIsLoadingState(false);
      } else {
        setDeleteData(null);
        setIsLoadingState(false);
      }
    } catch (e) {
      setIsLoadingState(false);
    }
  };

  const handleCofirmModalOpen = (value) => {
    setConfirmDelete(value);
  };
  // const actionHead = (data) => {
  //   return (<div style={{display: "flex"}}>
  //      hi
  //   </div>);
  // };

  return (
    <>
      {(billerPartyList?.loading || isLoadingState) && <Loader />}
      <MatTable
        loading={billerPartyList?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        // requestSearch={requestSearch}
        // cancelSearch={cancelSearch}
        // onApplyFilter={(data = {}) => {
        //   getListing({
        //     page: String(1),
        //     start_date: '',
        //     end_date: '',
        //     ...getObjectSubset(data, 'start_date', 'end_date'),
        //   });
        //   if (Object.keys(data).length > 0) {
        //     setAllParams({
        //       ...allParams,
        //       page: String(1),
        //       ...getObjectSubset(data, 'start_date', 'end_date'),
        //     });
        //   } else {
        //     setAllParams({
        //       page: String(1),
        //     });
        //   }
        // }}
        // showFilterButton={true}
        // showSerialNo={false}
        action={actionBody}
        // actionHead={actionHead}
        page={page}
        // changeFilter={changeFilter}
        // handleFilterPopup={toggleFilters}
        perPage={limit}
        // setFilters={setFilters}
        // filters={filters}
        total={billerPartyList?.items?.totalResults || 0}
        // defaultSort="transactionTime"
        // defaultSortOrder={isMobile ? sortOrder : 'desc'}
        // searchTerm={searchTerm}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          // setAllParams({
          //   ...allParams,
          //   page: String(1),
          //   search: searchTerm,
          // });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          // setAllParams({
          //   ...allParams,
          //   page: String(newPage),
          // });
        }}
        checkboxEnable={false}
        toolbarEnable={true}
        // toolBarButton={() => {
        //   return (
        //     <CustomButton
        //       sx={(theme) => ({
        //         fontSize: '12px',
        //         whiteSpace: 'nowrap',
        //         bgcolor: 'buttonSecondary.main',
        //         color: 'buttonSecondary.contrastText',
        //         [theme.breakpoints.down('md')]: {
        //           flex: 1,
        //         },
        //       })}
        //       onClick={() => {
        //         getExportFile();
        //       }}
        //       loading={expLoading}
        //     >
        //       Export XLS
        //     </CustomButton>
        //   );
        // }}
        pagination={true}
        filtersUrlData={allParams || {}}
        filterEnable
        rangeDateFilter
        onDelete={() => {}}
        dropdownFilter={true}
        // dropdownFilterOptions={ContactUsFiltersData.related_to}
      />
      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleConfirm={handleDelete}
          setOpen={handleCofirmModalOpen}
        />
      )}
    </>
  );
}

export default AllBillerParty;
